<header id="header-container">
    <!-- Topbar -->
    <div id="top-bar">
        <div class="container">
            <!-- Left Side Content -->
            <div class="left-side">
                <!-- Top bar -->
                <ul class="top-bar-menu">
                    <li><i class="fa fa-phone"></i><a aria-label="pakmatti.com admin phone number" href="tel:03178611123">031-786-111-23</a> </li>
                    <li><i class="fa fa-envelope"></i> <a aria-label="pakmatti.com admin email address" href="mailto:admin@pakmatti.com">
                            <span>admin&#64;pakmatti.com</span></a>
                    </li>
                </ul>
            </div>
            <!-- Left Side Content / End -->
            <!-- Left Side Content -->
            <div class="right-side">
                <!-- Social Icons -->
                <ul class="social-icons">
                    <li><a class="facebook" aria-label="pakmatti.com Facebook page"  href="https://www.facebook.com/pakmatti" target="_blank" ><i class="icon-facebook"></i></a></li>
                    <li><a class="youtube" aria-label="pakmatti.com YouTube channel" href="https://www.youtube.com/@PAKMATTI" target="_blank"><i class="icon-youtube"></i></a></li>
                </ul>
            </div>
            <!-- Left Side Content / End -->
        </div>
    </div>
    <div class="clearfix"></div>
    <!-- Topbar / End -->
    <!-- Header -->
    <div id="header">
        <div class="container">

            <!-- Left Side Content -->
            <div class="left-side">

                <!-- Logo -->
                <div id="logo">
                  <a [routerLink]="'/'" aria-label="pakmatti.com home page"><img width="40" height="40" src="/assets/images/pak-matti-logo.webp" alt="pakmatti.com logo"></a>
                </div>

                <!-- Mobile Navigation -->
                <div class="mmenu-trigger">
                    <button class="hamburger hamburger--collapse" type="button" aria-label="Mobile Navigation">
                        <span class="hamburger-box">
                            <span class="hamburger-inner"></span>
                        </span>
                    </button>
                </div>

                <!-- Main Navigation -->
                <app-navigation>Navigation..</app-navigation>
                <div class="clearfix"></div>
                <!-- Main Navigation / End -->

            </div>
            <!-- Left Side Content / End -->
            <!-- Right Side Content / End -->
            <div class="right-side">
                <!-- Header Widget 1-->
                 @if(header_control1) {
                <div class="header-widget">
                    <a [routerLink]="'/login-register'" class="sign-in" aria-label="pakmatti.com Log In / Register"><i class="fa fa-user"></i> Log In / Register</a>
                    <a [routerLink]="'/property/forms/submit'" class="button button-blue" aria-label="Add property pakmatti.com"> + Add Property </a>
                </div>
              }
                <!-- Header Widget / End 1 -->
                <!-- New header-widget Starts Here. -->
                 @if(header_control2) {
                <div class="header-widget">
                    <!-- User Menu -->
                    <div class="user-menu">
                        <div class="user-name"><span><img [src]="ImageUrl" alt="UserName" width="40" height="40"></span>Hi, {{UserName}}</div>
                        <ul>
                            <li><a [routerLink]="'/account/profile'"><i class="sl sl-icon-user"></i> My Profile</a></li>
                            <li><a [routerLink]="'/account/properties'"><i class="sl sl-icon-docs"></i> My Properties</a></li>
                            <li><a [routerLink]="'/account/change-password'"><i class="sl sl-icon-lock"></i> Change Password</a></li>
                            <li><a [routerLink]="'/'" (click)="Logout()"><i class="sl sl-icon-power"></i> Log Out</a></li>
                        </ul>
                    </div>

                    <a [routerLink]="'/property/forms/submit'" class="button button-blue" aria-label="Add property pakmatti.com"> + Add Property</a>
                </div>
              }
                <!-- New header-widget Ends Here. -->
            </div>
            <!-- Right Side Content / End -->
        </div>

    </div>

    <div id="header" class="cloned unsticky">
            <div class="container">

                <!-- Left Side Content -->
                <div class="left-side">

                    <!-- Logo -->
                    <div id="logo">
                        <a [routerLink]="'/'" aria-label="pakmatti.com home page"><img width="40" height="40" src="/assets/images/pak-matti-logo.webp" alt="pakmatti.com"></a>
                    </div>

                    <!-- Mobile Navigation -->
                    <div class="mmenu-trigger">
                        <button class="hamburger hamburger--collapse" type="button" aria-label="Mobile Navigation">
                            <span class="hamburger-box">
                                <span class="hamburger-inner"></span>
                            </span>
                        </button>
                    </div>

                    <!-- Main Navigation -->
                    <app-navigation></app-navigation>
                    <div class="clearfix"></div>
                    <!-- Main Navigation / End -->

                </div>
                <!-- Left Side Content / End -->
                <!-- Right Side Content / End -->
                <div class="right-side">
                    <!-- Header Widget 1-->
                     @if(header_control1) {
                    <div class="header-widget">
                        <a [routerLink]="'/login-register'" class="sign-in" aria-label="pakmatti.com Log In / Register"><i class="fa fa-user"></i> Log In / Register</a>
                        <a [routerLink]="'/property/forms/submit'" class="button button-blue" aria-label="Add property pakmatti.com"> + Add Property</a>
                    </div>
                  }
                    <!-- Header Widget / End 1 -->

                    <!-- New header-widget Starts Here. -->
                     @if(header_control2) {
                    <div class="header-widget">
                        <!-- User Menu -->
                        <div class="user-menu">
                            <div class="user-name"><span><img [src]="ImageUrl" alt="UserName" width="40" height="40"></span>Hi, {{UserName}}</div>
                            <ul>
                                <li><a [routerLink]="'/account/profile'"><i class="sl sl-icon-user"></i> My Profile</a></li>
                                <li><a [routerLink]="'/account/properties'"><i class="sl sl-icon-docs"></i> My Properties</a></li>
                                <li><a [routerLink]="'/account/change-password'"><i class="sl sl-icon-lock"></i> Change Password</a></li>
                                <li><a [routerLink]="'/'" (click)="Logout()"><i class="sl sl-icon-power"></i> Log Out</a></li>
                            </ul>
                        </div>

                        <a [routerLink]="'/property/forms/submit'" class="button button-blue" aria-label="Add property pakmatti.com"> + Add Property</a>
                    </div>
                  }
                    <!-- New header-widget Ends Here. -->
                </div>
                <!-- Right Side Content / End -->
            </div>

        </div>
    <!-- Header / End -->
</header>
